import { RequestStatusType } from '@Enums/requestStatusType.enum';
import { RecipientStatusType } from '@Enums/recipientStatusType.enum';

/**
 * Maps resolved document + recipient statuses to a redirect route name,
 * or null to allow access. Terminal document statuses (Canceled, ClosedIncomplete,
 * Success) are checked first, followed by an interleaved priority order where
 * some recipient statuses (e.g. Declined) outrank lower-severity document statuses.
 */
export function getSigningRequestRedirect(
    docStatus: RequestStatusType,
    recipientStatus: RecipientStatusType
): string | null {
    if (docStatus === RequestStatusType.Canceled) return 'request-canceled';
    if (docStatus === RequestStatusType.ClosedIncomplete) {
        if (recipientStatus === RecipientStatusType.Signed) return 'dashboard';
        return 'request-voided';
    }
    if (docStatus === RequestStatusType.Success) return 'dashboard';
    if (recipientStatus === RecipientStatusType.Declined) return 'decline';
    if (docStatus === RequestStatusType.Rejected) return 'request-decline';
    if (docStatus === RequestStatusType.Retry ||
        docStatus === RequestStatusType.Blocked) return 'error';
    if (docStatus === RequestStatusType.UnderReview ||
        recipientStatus === RecipientStatusType.ManualReview) return 'manual-review';
    if (recipientStatus === RecipientStatusType.Signed) return 'complete';
    if (recipientStatus === RecipientStatusType.Started ||
        docStatus === RequestStatusType.Started ||
        docStatus === RequestStatusType.InProgress) return null;
    return 'not-found';
}
